export function scrollToAnchor(
  targetId: string,
  {
    behavior = 'smooth',
    updateHash = true,
  }: { behavior?: ScrollBehavior; updateHash?: boolean } = {}
): boolean {
  if (typeof window === 'undefined') return false;

  const element = document.getElementById(targetId);
  if (!element) return false;

  element.scrollIntoView({ behavior, block: 'start' });

  if (updateHash) {
    const url = `${window.location.pathname}${window.location.search}#${targetId}`;
    window.history.replaceState(null, '', url);
  }

  return true;
}
